export enum MOBILE_WARNING_MODAL_TRACK_EVENTS {
  MODAL_SHOWN = 'mobile_warning_modal_shown',
  MODAL_DISMISSED = 'mobile_warning_modal_dismissed',
}
